import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

/**
 * Custom Link component that preserves iframe-related URL parameters
 */
export const IframeLink: React.FC<LinkProps> = ({ to, ...props }) => {
  const location = useLocation();
  
  // Parse current URL parameters
  const currentParams = new URLSearchParams(location.search);
  
  // Preserve iframe-related parameters
  const preservedParams = new URLSearchParams();
  
  // List of parameters to preserve
  const paramsToPreserve = ['hideNav', 'hidenav', 'tenant', 'user'];
  
  paramsToPreserve.forEach(param => {
    const value = currentParams.get(param);
    if (value !== null) {
      preservedParams.set(param, value);
    }
  });
  
  // Construct the new path with preserved params
  const toPath = typeof to === 'string' ? to : to.pathname || '';
  const separator = toPath.includes('?') ? '&' : '?';
  const paramsString = preservedParams.toString();
  const newTo = paramsString ? `${toPath}${separator}${paramsString}` : toPath;
  
  return <Link {...props} to={newTo} />;
};